import { useQuery } from '@tanstack/react-query';
import { api, usdFromMicros } from '../api.js';

export default function Costs() {
  const summaryQ = useQuery({ queryKey: ['costs/summary'], queryFn: () => api.costSummary() });
  const byFeatureQ = useQuery({
    queryKey: ['costs/by-feature'],
    queryFn: () => api.costByFeature(),
  });
  const byProviderQ = useQuery({
    queryKey: ['costs/by-provider'],
    queryFn: () => api.costByProvider(),
  });
  const budgetsQ = useQuery({ queryKey: ['budgets'], queryFn: () => api.budgets() });

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-semibold">Custos</h1>

      {summaryQ.data && (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          <Stat label="Hoje" value={usdFromMicros(summaryQ.data.todayMicros)} />
          <Stat label="Mês" value={usdFromMicros(summaryQ.data.monthMicros)} />
          <Stat label="Cache hits" value={summaryQ.data.cacheHits} />
          <Stat label="Leads qualificados" value={summaryQ.data.qualified} />
        </div>
      )}

      <div className="grid md:grid-cols-2 gap-6">
        <Table
          title="Por feature"
          rows={byFeatureQ.data ?? []}
          keys={['feature_key', 'calls']}
          money="amount"
        />
        <Table
          title="Por provider"
          rows={byProviderQ.data ?? []}
          keys={['provider', 'calls']}
          money="amount"
        />
      </div>

      <section className="bg-white border border-slate-200 rounded-xl overflow-hidden">
        <div className="px-4 py-3 border-b border-slate-200 text-sm font-medium text-slate-700">
          Budgets
        </div>
        {budgetsQ.data && budgetsQ.data.length ? (
          <table className="w-full text-sm">
            <thead className="text-xs text-slate-500 bg-slate-50">
              <tr>
                <th className="text-left px-3 py-2">Escopo</th>
                <th className="text-left px-3 py-2">Período</th>
                <th className="text-right px-3 py-2">Limite</th>
                <th className="text-right px-3 py-2">Warn %</th>
                <th className="text-left px-3 py-2">Hard stop</th>
              </tr>
            </thead>
            <tbody>
              {budgetsQ.data.map((b) => (
                <tr key={b.id} className="border-t border-slate-100">
                  <td className="px-3 py-2">
                    {b.scope_type}
                    {b.scope_id ? ` (${b.scope_id})` : ''}
                  </td>
                  <td className="px-3 py-2">{b.period}</td>
                  <td className="px-3 py-2 text-right">{usdFromMicros(b.limit_microusd)}</td>
                  <td className="px-3 py-2 text-right">{b.warning_percent}%</td>
                  <td className="px-3 py-2">{b.hard_stop ? 'sim' : 'não'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className="p-6 text-slate-500 text-sm">Nenhum budget definido.</div>
        )}
      </section>
    </div>
  );
}

function Stat({ label, value }) {
  return (
    <div className="bg-white border border-slate-200 rounded-xl p-4">
      <div className="text-slate-500 text-xs uppercase tracking-wide">{label}</div>
      <div className="text-2xl font-semibold mt-1">{value}</div>
    </div>
  );
}

function Table({ title, rows, keys, money }) {
  return (
    <section className="bg-white border border-slate-200 rounded-xl overflow-hidden">
      <div className="px-4 py-3 border-b border-slate-200 text-sm font-medium text-slate-700">
        {title}
      </div>
      {rows.length ? (
        <table className="w-full text-sm">
          <thead className="text-xs text-slate-500 bg-slate-50">
            <tr>
              {keys.map((k) => (
                <th key={k} className="text-left px-3 py-2">
                  {k}
                </th>
              ))}
              <th className="text-right px-3 py-2">gasto</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r, i) => (
              <tr key={i} className="border-t border-slate-100">
                {keys.map((k) => (
                  <td key={k} className="px-3 py-2">
                    {r[k]}
                  </td>
                ))}
                <td className="px-3 py-2 text-right">{usdFromMicros(r[money])}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <div className="p-6 text-slate-500 text-sm">Sem dados ainda.</div>
      )}
    </section>
  );
}
